export default {
  CSRFToken: "",
  window: {
    isPageobject: false,
    isProjectAdmin: false,
    https_redirect: undefined,
    webLogo: "",
    noheader: false,
    CSRFToken: "",
    testcaseProject: "",
    pageobject_id: "",
    testcase_id: "",
    is_modeler_access: false,
    expirationmessage: "",
    is_user_tester: false,
    is_login: false,
    current_release_version: "",
    teamowner: "",
    unreadMessageCount: 0,
    login_user_id: "",
    expiration_date: "",
    checkAccessInfo: undefined,
    copyrighttext: "",
    swappingUID: "",
    stability_tags: [],
    allowed_file_extensions: "",
    executiveBaseUrl: "",
    legacy_cv_model: false,
    enableScriptImport: false,
    enableTailscale: false,
  },
  readOnly: true,
  visible: true,
  breadcrumbsData: {},
  dialog: {
    show: false,
    width: "Max(30vw, 500px)",
    title: "",
    titleIcon: "",
    content: "",
    contentHTML: "",
    onSubmit: () => {
    },
    onCancel: () => {
    },
    submitText: "",
    cancelText: "",
    submitIcon: "",
    cancelIcon: "",
    hideOnCancel: false,
    loading: false,
    cancelLoading: false
  },
  archFlag: false,
  updateArchFlag: false,
  tabFocused: true,
  messagesCount: 0,
  testListingDraggingItem: [],
  invalidRoute: false
};
